export default __webpack_public_path__ + "static/media/ways.1d6967d2.png";